module.exports = __webpack_public_path__ + "static/media/uoa-12.36008478.jpg";